import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './consoleFilters';

import React from 'react';
import ReactDOM from 'react-dom';

import {
  APP_INIT_ERROR, APP_READY, initialize, mergeConfig, subscribe,
} from '@edx/frontend-platform';
import { fetchAuthenticatedUser, getAuthenticatedUser } from '@edx/frontend-platform/auth';
import { ErrorPage } from '@edx/frontend-platform/react';

import configuration from './config';
import messages from './i18n';
import MainApp from './MainApp';

subscribe(APP_READY, () => {
  const renderApp = () => {
    ReactDOM.render(
      <MainApp />,
      document.getElementById('root'),
    );
  };

  const cachedUser = getAuthenticatedUser();
  const hasSessionCookie = typeof document !== 'undefined'
    && /(?:^|;\s*)sessionid=/.test(document.cookie || '');
  if ((!cachedUser || !cachedUser.username) && !hasSessionCookie) {
    renderApp();
    return;
  }

  // Refresh only when we likely have a real session.
  fetchAuthenticatedUser({ forceRefresh: Boolean(cachedUser && cachedUser.username) })
    .catch(() => null)
    .finally(renderApp);
});

subscribe(APP_INIT_ERROR, (error) => {
  ReactDOM.render(<ErrorPage message={error.message} />, document.getElementById('root'));
});

initialize({
  handlers: {
    config: () => {
      mergeConfig(configuration);
    },
  },
  messages,
});
